"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const messageTranslations = {
    empty: {
        noConversation: "No Conversation Currently Open",
        selectConversation: "Please select a conversation",
        removedGroupMessage: "You can't send messages to this group because you're no longer a participant",
        deletedChatMessage: "You can't send messages to this chat because it has been deleted",
    },
    add: "Add",
    addUser: "Add User",
    addMember: "Add Member",
    addMembersFromMap: "Add Members From Map",
    memberAddedSuccessfully: " member added successfully",
    membersAddedSuccessfully: " member(s) added successfully",
    addedSuccessfullyTo: " added successfully to ",
    searchChat: "Search Chat",
    voiceCall: "Voice Call",
    videoCall: "Video Call",
    chatInfo: "Chat Info",
    moreOptions: "More Options",
    muteNotifications: "Mute Notifications",
    confirmAddUserPrefix: "Are you sure you want to add ",
    confirmAddUserSuffix: " ?",
    alreadyAdded: "Already added to group",
    placeHolder: {
        message: "Message",
    },
    message: {
        you: "You",
        priorityMessage: "Priority Message",
        ack: "Ack",
        acknowledge: "Acknowledge",
        acknowledged: "Acknowledged",
        acknowledgedSelf: "Me",
        acknowledgeSelf: "Me - Tap to Acknowledge",
        moreAcknowledge: "more",
        audio: {
            notSupported: "Your browser does not support the audio tag.",
        },
        video: {
            notSupported: "Your browser does not support HTML5 video.",
        },
        media: {
            loadFailed: "Couldn't load media",
            tapToRetry: "Tap to retry",
            docOpenFailed: "Couldn't open document. Please try again.",
        },
        priorityLabel: "Priority Message On",
        sendingStatus: "Sending...",
        sendFailedStatus: "Not sent",
        editFailedStatus: "Edit failed",
        sendRejectedStatus: "Failed",
        sendFailedAction: "Retry",
        deletedMessage: "This message was deleted",
        starFailed: "Failed to star the message",
        unStarFailed: "Failed to remove star from the message",
        unStarAllSuccess: "All messages un-starred successfully",
        noReplyMessage: "Reply message not available",
    },
    unsentMessages: {
        title: "Unsent messages",
        description: "Some messages in this chat haven't been sent yet. You can come back and retry them.",
        leave: "Leave anyway",
        stay: "Stay",
    },
    loadingMessage: "Loading Messages",
    preview: {
        previewLabel: "Preview",
        dropFiles: "Drop your files here",
        addCaption: "Add a caption",
        fileNotSupported: "Invalid file format",
        fileSizeError: "File(s) size cannot exceed {{ maxFileSize }} MB",
        imageSizeError: "Image(s) cannot be more than {{ imageMaxSize }} MB",
        documentSizeError: "Document(s) cannot be more than {{ documentMaxSize }} MB",
        audioVideoSizeError: "Audio(s)/Video(s) cannot be more than {{ audioVideoMaxSize }} MB",
        maxFileError: "Max {{ maxFilesUpload }} files upload",
        totalSizeError: "Total file size exceeds {{ maxSize }} MB limit",
        bulkUploadConfirmTitle: "Upload Confirmation",
        bulkUploadConfirmMessage: "You are about to upload {{ count }} files. Do you want to continue?",
        bulkUploadConfirmButton: "Upload",
        uploadError: "Error in uploading : ",
    },
    search: {
        placeholder: "Search by message",
        filterPlaceholder: "Filter by sender name",
        sendersSelected: "sender(s) selected",
        caption: "You can't send messages to this group while searching..",
    },
    referral: {
        refuse: "Refuse",
        accept: "Accept",
        refuseTitle: "Refuse Referral Message",
        reason: "Give your reason",
        cancel: "CANCEL",
        submit: "SUBMIT",
        acceptSnackbarMessage: "Referral Accepted Successfully!",
        refuseSnackbarMessage: "Referral Refused Successfully!",
        confirmRevokeReferral: "Are you sure you want to revoke this referral?",
        revoke: "Revoke",
        revokeReferral: "Revoke Referral",
        referralMessage: "Referral Message",
        referralSentSuccessfullyTo: "Referral sent successfully to ",
        invitationFor: "Invitation for ",
        failedRevokingReferral: " Failed to revoke referral",
        hasBeenRevoked: " has been revoked",
        messageInput: "Enter Referral Message",
        placeholderText: "Ex. Hello Mr. example Please accept referral",
        sendReferral: "Send Referral",
        add: "+Add",
    },
    smartContent: {
        title: "Hi, these {{clinicians}}s are seeing patients within ",
        emptyTitle: "Hi, there are no clinicians currently seeing any patients within ",
        advancedSearchTitle: "For more suggestions use:",
        advancedSearchText: "Advanced Search",
        patientsNearby: "Patients nearby: ",
        closestPatient: "Closest patient: ",
        miles: " miles",
        addedToGroup: "Added to group",
        sendingReferral: "Sending Referral",
        sendReferralModalTitle: "Send for Referral",
        enterReferralMessage: "Enter referral message",
        sentReferral: "Sent Referral Invite",
        referralMessage: "Referral Message",
        revokeReferral: "Revoke Referral",
        addMember: "Add Member",
    },
    Reminder: "Reminder",
    Title: "Title",
    Date: "Date",
    Time: "Time",
    Message: "Message",
    reminder: {
        invalidTitle: "Please enter title",
        invalidDate: "Please select date",
        invalidTime: "Please select time",
        invalidMessage: "Please enter message",
    },
    templateMessage: "Template Message",
    templateAccess: "Template Access",
    cancel: "CANCEL",
    contextMenu: {
        info: "Info",
        askForAcknowledgement: "Ask for acknowledgement",
        starMessage: "Star message",
        unstarMessage: "Unstar message",
        forwardMessage: "Forward message",
        deleteMessage: "Delete message",
        edit: "Edit",
        reply: "Reply",
        visibleToPatient: "Visible to Patient",
        visibleToPhysician: "Visible to Physician",
        copy: "Copy",
        resend: "Resend",
        resendAsPriority: "Resend as Priority",
    },
    contextMenuMessages: {
        messageCopied: "Message copied successfully",
        resendMessageError: "Error while sending message!",
        resendAsPriorityError: "Error while sending message!",
        copyMessageError: "Error while copying message!",
    },
    scrollUpToViewMessage: "Please scroll up to view the message",
    newMessagesDivider: "New messages",
    advancedSearch: {
        nearby: "Nearby: ",
        closest: "Closest: ",
    },
    forwardedMessage: "Forwarded",
    forwardedFrom: "Forwarded from ",
    editingMessage: "Editing message",
    edited: "Edited",
    visibleToPatient: "* All new messages will be visible to patient",
    visibleToPhysician: "* All new messages will be visible to physician",
    visibleToPatientAndPhysician: "* All new messages will be visible to patient & physician",
    userOnDND: "This user has Do Not Disturb enabled",
    notes: "Notes: ",
    pendingReferrals: "{{pendingReferralCount}} pending referral(s)",
    pendingReferralsAndMore: "+ {{moreCount}} more",
    youHavePendingAcknowledgments: "You have pending acknowledgments",
    shareLocation: "Share Location",
    searchForLocation: "Search for location",
    searchLocation: "Search for a location",
    share: "Share",
    gettingLocation: "Getting your location...",
    gettingAddress: "Getting address...",
    moveMapToSelect: "Move map to select location",
    selectLocation: "Select a location to share",
    locationPermissionDenied: "Location permission denied",
    unableToGetLocation: "Unable to get your location",
    messageComposer: {
        patientConfirmationDialogTitle: "A Patient or Physician was Acknowledged",
        patientConfirmationDialog: "A patient or physician was acknowledged in this message, but the message is not visible to them. Do you want to make the message visible to them?",
        yesVisibleAction: "Yes",
        dontVisibleAction: "No, Edit message",
    },
    patientConfirmation: {
        dialogTitle: "Visible to Patient/Physician",
        dialogMessage: "This message has acknowledged a patient. Do you want to make this message visible to patient?",
        dialogMessagePhysician: "This message has acknowledged a physician. Do you want to make this message visible to physician?",
        dialogMessageBoth: "This message has acknowledged a patient and physician. Do you want to make this message visible to both?",
        confirmationButtonText: "Yes, make it visible.",
        confirmationCancelText: "No, keep it private",
    },
};
exports.default = messageTranslations;
